module.exports = __webpack_public_path__ + "img/1KGYjmWU71R5uTNI2gSmWazL2g9zcx9Qd.242e6d91.png";